import { z } from 'zod';

const AwsSecretSchema = z.object({
  AccessKeyId: z.string(),
  SecretAccessKey: z.string(),
  SessionToken: z.string(),
  Expiration: z.string(),
  Region: z.string()
});
const CredentialsProviderSchema = z.function().returns(z.promise(AwsSecretSchema));

var Brand;
(function (Brand) {
  Brand["AUDI"] = "A";
  Brand["VW"] = "V";
  Brand["SKODA"] = "C";
  Brand["BENTLEY"] = "E";
  Brand["LAMBORGHINI"] = "L";
  Brand["MAN_TRUCKS_BUS"] = "M";
  Brand["VW_NUTZFAHRZEUGE"] = "N";
  Brand["PORSCHE"] = "P";
  Brand["SEAT"] = "S";
})(Brand || (Brand = {}));
const BrandSchema = z.nativeEnum(Brand);

var Market;
(function (Market) {
  Market["ARE"] = "ARE";
  Market["ARG"] = "ARG";
  Market["AUS"] = "AUS";
  Market["AUT"] = "AUT";
  Market["BEL"] = "BEL";
  Market["BGR"] = "BGR";
  Market["BHR"] = "BHR";
  Market["BOL"] = "BOL";
  Market["BRA"] = "BRA";
  Market["CAN"] = "CAN";
  Market["CHE"] = "CHE";
  Market["CHL"] = "CHL";
  Market["CHN"] = "CHN";
  Market["COL"] = "COL";
  Market["CRI"] = "CRI";
  Market["CUW"] = "CUW";
  Market["CYM"] = "CYM";
  Market["CYP"] = "CYP";
  Market["DEU"] = "DEU";
  Market["DNK"] = "DNK";
  Market["DOM"] = "DOM";
  Market["ECU"] = "ECU";
  Market["EGY"] = "EGY";
  Market["ESP"] = "ESP";
  Market["EST"] = "EST";
  Market["FIN"] = "FIN";
  Market["FRA"] = "FRA";
  Market["GBR"] = "GBR";
  Market["GLP"] = "GLP";
  Market["GRC"] = "GRC";
  Market["GTM"] = "GTM";
  Market["GUF"] = "GUF";
  Market["HKG"] = "HKG";
  Market["HRV"] = "HRV";
  Market["HUN"] = "HUN";
  Market["IND"] = "IND";
  Market["IRL"] = "IRL";
  Market["ISR"] = "ISR";
  Market["ITA"] = "ITA";
  Market["JAM"] = "JAM";
  Market["JOR"] = "JOR";
  Market["JPN"] = "JPN";
  Market["KOR"] = "KOR";
  Market["KWT"] = "KWT";
  Market["LBN"] = "LBN";
  Market["LCA"] = "LCA";
  Market["LTU"] = "LTU";
  Market["LUX"] = "LUX";
  Market["LVA"] = "LVA";
  Market["MAR"] = "MAR";
  Market["MEX"] = "MEX";
  Market["MTQ"] = "MTQ";
  Market["NLD"] = "NLD";
  Market["NOR"] = "NOR";
  Market["NZL"] = "NZL";
  Market["OMN"] = "OMN";
  Market["PAN"] = "PAN";
  Market["PER"] = "PER";
  Market["POL"] = "POL";
  Market["PRT"] = "PRT";
  Market["PRY"] = "PRY";
  Market["QAT"] = "QAT";
  Market["ROU"] = "ROU";
  Market["RUS"] = "RUS";
  Market["SAU"] = "SAU";
  Market["SRB"] = "SRB";
  Market["SGP"] = "SGP";
  Market["SLV"] = "SLV";
  Market["SVK"] = "SVK";
  Market["SWE"] = "SWE";
  Market["SXM"] = "SXM";
  Market["THA"] = "THA";
  Market["TTO"] = "TTO";
  Market["TUR"] = "TUR";
  Market["TWN"] = "TWN";
  Market["URY"] = "URY";
  Market["USA"] = "USA";
  Market["VAT"] = "VAT";
  Market["VEN"] = "VEN";
  Market["VNM"] = "VNM";
  Market["ZAF"] = "ZAF";
})(Market || (Market = {}));
const MarketSchema = z.nativeEnum(Market);
const defaultLanguageFor = market => orderedLanguagesPerMarket[market][0];
const orderedLanguagesPerMarket = {
  [Market.ARE]: ['en'],
  [Market.ARG]: ['es'],
  [Market.AUS]: ['en'],
  [Market.AUT]: ['de'],
  [Market.BEL]: ['fr', 'nl'],
  [Market.BGR]: ['bg'],
  [Market.BHR]: ['en'],
  [Market.BOL]: ['es'],
  [Market.BRA]: ['pt'],
  [Market.CAN]: ['en', 'fr'],
  [Market.CHE]: ['de', 'it', 'fr'],
  [Market.CHL]: ['es'],
  [Market.CHN]: ['zh'],
  [Market.COL]: ['es'],
  [Market.CRI]: ['es'],
  [Market.CUW]: ['en', 'nl'],
  [Market.CYM]: ['en'],
  [Market.CYP]: ['el', 'tr'],
  [Market.DEU]: ['de'],
  [Market.DNK]: ['da'],
  [Market.DOM]: ['es'],
  [Market.ECU]: ['es'],
  [Market.EGY]: ['en'],
  [Market.ESP]: ['es'],
  [Market.EST]: ['et'],
  [Market.FIN]: ['fi'],
  [Market.FRA]: ['fr'],
  [Market.GBR]: ['en'],
  [Market.GLP]: ['fr'],
  [Market.GRC]: ['el'],
  [Market.GTM]: ['es'],
  [Market.GUF]: ['fr'],
  [Market.HKG]: ['en'],
  [Market.HRV]: ['hr'],
  [Market.HUN]: ['hu'],
  [Market.IND]: ['en'],
  [Market.IRL]: ['en'],
  [Market.ISR]: ['en'],
  [Market.ITA]: ['it'],
  [Market.JAM]: ['en'],
  [Market.JOR]: ['en'],
  [Market.JPN]: ['ja'],
  [Market.KOR]: ['ko'],
  [Market.KWT]: ['en'],
  [Market.LBN]: ['en'],
  [Market.LCA]: ['en'],
  [Market.LTU]: ['lt', 'ru'],
  [Market.LUX]: ['de', 'fr'],
  [Market.LVA]: ['lv', 'ru'],
  [Market.MAR]: ['en'],
  [Market.MEX]: ['es'],
  [Market.MTQ]: ['fr'],
  [Market.NLD]: ['nl'],
  [Market.NOR]: ['no'],
  [Market.NZL]: ['en'],
  [Market.OMN]: ['en'],
  [Market.PAN]: ['es'],
  [Market.PER]: ['es'],
  [Market.POL]: ['pl'],
  [Market.PRT]: ['pt'],
  [Market.PRY]: ['es'],
  [Market.QAT]: ['en'],
  [Market.ROU]: ['ro'],
  [Market.RUS]: ['ru'],
  [Market.SAU]: ['en'],
  [Market.SRB]: ['rs'],
  [Market.SGP]: ['en'],
  [Market.SLV]: ['es'],
  [Market.SVK]: ['sk'],
  [Market.SWE]: ['sv'],
  [Market.SXM]: ['en', 'nl'],
  [Market.THA]: ['th', 'en'],
  [Market.TTO]: ['en'],
  [Market.TUR]: ['tr'],
  [Market.TWN]: ['zh'],
  [Market.URY]: ['es'],
  [Market.USA]: ['en'],
  [Market.VAT]: ['en'],
  [Market.VEN]: ['en'],
  [Market.VNM]: ['en'],
  [Market.ZAF]: ['en']
};
const marketToTwoLettercode = {
  [Market.ARE]: 'AE',
  [Market.ARG]: 'AR',
  [Market.AUS]: 'AU',
  [Market.AUT]: 'AT',
  [Market.BEL]: 'BE',
  [Market.BGR]: 'BG',
  [Market.BHR]: 'BH',
  [Market.BOL]: 'BO',
  [Market.BRA]: 'BR',
  [Market.CAN]: 'CA',
  [Market.CHE]: 'CH',
  [Market.CHL]: 'CL',
  [Market.CHN]: 'CN',
  [Market.COL]: 'CO',
  [Market.CRI]: 'CR',
  [Market.CUW]: 'CW',
  [Market.CYM]: 'KY',
  [Market.CYP]: 'CY',
  [Market.DEU]: 'DE',
  [Market.DNK]: 'DK',
  [Market.DOM]: 'DO',
  [Market.ECU]: 'EC',
  [Market.EGY]: 'EG',
  [Market.ESP]: 'ES',
  [Market.EST]: 'EE',
  [Market.FIN]: 'FI',
  [Market.FRA]: 'FR',
  [Market.GBR]: 'GB',
  [Market.GLP]: 'GP',
  [Market.GRC]: 'GR',
  [Market.GTM]: 'GT',
  [Market.GUF]: 'GF',
  [Market.HKG]: 'HK',
  [Market.HRV]: 'HR',
  [Market.HUN]: 'HU',
  [Market.IND]: 'IN',
  [Market.IRL]: 'IE',
  [Market.ISR]: 'IL',
  [Market.ITA]: 'IT',
  [Market.JAM]: 'JM',
  [Market.JOR]: 'JO',
  [Market.JPN]: 'JP',
  [Market.KOR]: 'KR',
  [Market.KWT]: 'KW',
  [Market.LBN]: 'LB',
  [Market.LCA]: 'LC',
  [Market.LTU]: 'LT',
  [Market.LUX]: 'LU',
  [Market.LVA]: 'LV',
  [Market.MAR]: 'MA',
  [Market.MEX]: 'MX',
  [Market.MTQ]: 'MQ',
  [Market.NLD]: 'NL',
  [Market.NOR]: 'NO',
  [Market.NZL]: 'NZ',
  [Market.OMN]: 'OM',
  [Market.PAN]: 'PA',
  [Market.PER]: 'PE',
  [Market.POL]: 'PL',
  [Market.PRT]: 'PT',
  [Market.PRY]: 'PY',
  [Market.QAT]: 'QA',
  [Market.ROU]: 'RO',
  [Market.RUS]: 'RU',
  [Market.SAU]: 'SA',
  [Market.SRB]: 'RS',
  [Market.SGP]: 'SG',
  [Market.SLV]: 'SV',
  [Market.SVK]: 'SK',
  [Market.SWE]: 'SE',
  [Market.SXM]: 'SX',
  [Market.THA]: 'TH',
  [Market.TTO]: 'TT',
  [Market.TUR]: 'TR',
  [Market.TWN]: 'TW',
  [Market.URY]: 'UY',
  [Market.USA]: 'US',
  [Market.VAT]: 'VA',
  [Market.VEN]: 'VE',
  [Market.VNM]: 'VN',
  [Market.ZAF]: 'ZA'
};

const _KvpsDealerIdSchema = z.string().brand();
function isKvpsDealerId(name) {
  const matcher = RegExp(/^(?<market>[A-Z]{3})([A-Z0-9]{5})(?<brand>[A-Z])$/).exec(name);
  const market = matcher?.groups?.market;
  const brand = matcher?.groups?.brand;
  return !!matcher && MarketSchema.safeParse(market).success && BrandSchema.safeParse(brand).success;
}
const KvpsDealerIdSchema = _KvpsDealerIdSchema.refine(isKvpsDealerId, name => ({
  message: `Not a valid kvpsDealerId: "${name}"`
}));
function getBrand(dealerId) {
  return BrandSchema.parse(dealerId.substring(8, 9));
}
function getMarket(dealerId) {
  return MarketSchema.parse(dealerId.substring(0, 3));
}

var Stage;
(function (Stage) {
  Stage["DEVELOP"] = "develop";
  Stage["PREPROD"] = "preprod";
  Stage["PROD"] = "prod";
})(Stage || (Stage = {}));
const StageSchema = z.nativeEnum(Stage);

/**
 * Constructs a logger instance from the given `factory` for the given `stage` if `factory` is present.
 * @param factory Logger factory.
 * @param stage Stage to get a logger instance for.
 * @returns A logger instance for `stage` if `factory` is present; otherwise `undefined`.
 */
const buildLogger = (factory, stage) => factory?.(stage);

const TlsClientCertKeyPairSchema = z.object({
  cert: z.string(),
  key: z.string()
});

export { AwsSecretSchema, Brand, BrandSchema, CredentialsProviderSchema, KvpsDealerIdSchema, Market, MarketSchema, Stage, StageSchema, TlsClientCertKeyPairSchema, buildLogger, defaultLanguageFor, getBrand, getMarket, isKvpsDealerId, marketToTwoLettercode, orderedLanguagesPerMarket };
